import { styler } from 'popmotion'

export default {
    props: {
        delay: { type: Number, default: 0 },
        interval: { type: Number, default: 10000 }
    },

    beforeDestroy() {
        this.stopAnimation()
    },

    async mounted() {
        await this.wait(280)
        // get the base element
        this.baseElement = document.querySelector(
            '#' + this.baseElementQueryString
        )
        // set the styles
        this.setStyler()
        // start the animaiton loop
        this.start()
    },

    methods: {
        // ---- ---- Controls for play and delays ---- ----
        async start() {
            const start_time = performance.now()
            await this.init()
            await this.wait(this.delay)
            await this.animate()
            const elapsed_time = performance.now() - start_time
            await this.wait(this.interval - elapsed_time)
            this.start()
        },

        async animate() {
            return new Promise((resolve, _) => {
                this.animation = this.animationAction().start({
                    update: this.animationReaction,
                    complete: resolve
                })
            })
        },

        async init() {
            return new Promise((resolve, reject) => {
                this.animation = this.initAction().start({
                    update: this.initReaction,
                    complete: resolve
                })
            })
        },

        async wait(delay) {
            // resolve if there is no delay
            if (delay <= 0) return Promise.resolve()
            //otherwise a promise that will resolve after the delay
            else
                return new Promise(
                    (resolve, _) =>
                        (this.waitTimer = setTimeout(() => resolve(), delay))
                )
        },

        // ---- ---- Controls for animations ---- -----

        initAction() {
            return action(({ update, complete }) => {
                update('No init supplied')
                complete()
            })
        },

        initReaction(v) {
            console.log(
                `init reaction for ${this.$options.name ||
                    this.$options._componentTag} - ${v}`
            )
        },

        animationAction() {
            return action(({ update }) => update('No action supplies'))
        },

        animationReaction(v) {
            console.log(
                `animation reaction for ${this.$options.name ||
                    this.$options._componentTag} - ${v}`
            )
        },

        stopAnimation() {
            clearTimeout(this.waitTimer)
            this.animation && this.animation.stop && this.animation.stop()
        },

        stylerGroup(queryString) {
            return Array.from(
                this.baseElement.querySelectorAll(queryString)
            ).map(e => styler(e))
        }
    },

    render(h) {
        return null
    }
}
